const triggerCustomerLookup = (country ,sessionId, externalRefId ,phoneNo, countryCode) => {
 
    const verifyUserHeaders = {
         "Content-Type": `application/json`,
          "x-wu-correlationId": sessionId,
          "x-wu-externalRefId": externalRefId,
          "WuCountryCode": country,
          "applicationSource": "WHATSAPP"

      };

    const customerDetail = {
        "customer": {
            "phoneNumber": [
                {
                    "countryCode": countryCode,
                    "number": phoneNo
                }
            ]
        }
    }

    const requestOptions = {
        method: "POST",
        body: JSON.stringify(customerDetail),
        headers: verifyUserHeaders
    };
    let CustomerResponse = {}
    try {
        return fetchApiWu('/cusprofile/v2/cust/customers/multiparam', requestOptions, 'verifyUser')
            .then((response) => {
               
                if(response.error){
                    return { "error":true ,"errorCode":response.error , "errorMsg":response.message}
                }
                return response
               
            })
    } catch(e) {
        console.log(e);
        return "error"
        
    }
    
};

window.queryData.triggerCustomerLookup = triggerCustomerLookup;